module.exports = __webpack_public_path__ + "static/img/0.f395b002.jpg";